/**
 * Created by wanghongxiang on 2017/6/27.
 */

export default {
  name: 'sn-layout',
  props: {
    href: String
  },
  mounted: function (h) {
    var ss = document.createElement('script')
    ss.setAttribute('src', this.href)
    document.head.appendChild(ss)
  },
  render (h) {
    // return <div domProps-innerHTML={this.frag}></div>
    return <div>
        <div id="widget" class="container"></div>
      </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/common/portal/Parser.js